export const TABLET_QUERY_WIDTH: string = '(max-width: 1024px)';
export const SERVICE_PAGINATION_MAX: number = 40;

export const INTERCOM_KEY: string = 'clwpw98v';
